"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchResultTranslationService = void 0;
const typings_1 = require("../typings");
const keyTranslationMap = {
    [typings_1.SearchResultTabKeyEnum.Pages]: 'pages',
    [typings_1.SearchResultTabKeyEnum.Products]: 'productsById',
    [typings_1.SearchResultTabKeyEnum.Documents]: 'documentsById',
    [typings_1.SearchResultTabKeyEnum.Drawings]: 'visualsById',
    [typings_1.SearchResultTabKeyEnum.Downloads]: 'softwareById',
};
class SearchResultTranslationService {
    constructor() {
        this.provideStructureAndTranslatedLabel = (options, dictionary) => {
            return options === null || options === void 0 ? void 0 : options.map(item => ({
                value: item.value,
                label: dictionary[item.label] || item.label,
                selected: item.isRefined,
                count: item.count,
            }));
        };
        this.transformToDictionary = (data = [], key = 'slug') => {
            return data.reduce((acc, item) => {
                acc[item[key]] = item.name;
                return acc;
            }, {});
        };
        this.transformToContentDictionary = (translations = {}, selectedTab) => {
            if (!translations) {
                return {};
            }
            if ((selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.source) === 'products') {
                return this.transformToContentProductsDictionary(translations[keyTranslationMap[selectedTab.key]]);
            }
            if ((selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.source) === 'assets') {
                return this.transformToContentAssetsDictionary(translations[keyTranslationMap[selectedTab.key]]);
            }
            return {};
        };
        this.transformToContentAssetsDictionary = (data = []) => {
            return data.reduce((acc, item) => {
                acc[item === null || item === void 0 ? void 0 : item.id] = { title: item === null || item === void 0 ? void 0 : item.title };
                return acc;
            }, {});
        };
        this.transformToContentProductsDictionary = (data = []) => {
            return data.reduce((acc, item) => {
                acc[item === null || item === void 0 ? void 0 : item.id] = { title: item === null || item === void 0 ? void 0 : item.headline, description: item === null || item === void 0 ? void 0 : item.description };
                return acc;
            }, {});
        };
    }
}
exports.searchResultTranslationService = new SearchResultTranslationService();
